import { Controller } from "stimulus" ;

class SampleTestController extends Controller {
  static targets = ["input", "output"];

  copy() {
    this.targets.find("output").value =
      this.targets.find("input").value;
  }
}

export default SampleTestController;
